import { trigger, state, style, transition, animate } from '@angular/animations';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as Sentry from '@sentry/angular';
import { MediaMatcher } from '@angular/cdk/layout';
import { MapHelperService } from 'src/services/map-helper.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { EstatusJSON } from 'src/app/features/shared/models/EstatusJSON';
import { IGeoPosDataLocation } from 'src/app/features/map-features/sections/route-section/models/IDataLocation';
import { CitronellaActionsService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/CitronellaActions.service';
import { SwalNotificationService } from 'src/app/features/shared/services/SwalNotification.service';
import { NotificationsToastService } from 'src/app/features/shared/services/Notifications-Toast.service';
import { LocalStorageService } from 'src/app/features/shared/services/LocalStorage.service';
import { MatTabChangeEvent } from '@angular/material/tabs';

import { environment } from "src/environments/environment";
import { EnumDetailIconNames, EnumGenericDetailProperties } from 'src/app/features/shared/helpers/enums/EnumDetailsImages';
import { RouteSheetTab } from 'src/app/features/map-features/sections/locations-section/models/RouteSheetTab';
import { EnumLocationCategories } from 'src/app/features/shared/helpers/enums/EnumLocationCategories';
import { LocationCategoryDTO } from 'src/app/features/map-features/sections/locations-section/models/LocationCategoryDTO';
import { DataNamesDTO } from '../../../../../models/DataNamesDTO';
import { LocationDTO } from '../../../../../models/LocationDTO';
import { LocationsService } from '../../../../../services/Locations.service';
import { RouteSheetUtilService } from 'src/app/features/map-features/ui/organisms/route-sheet/service/RouteSheetUtil.service';
import { RouteSheetService } from 'src/app/features/map-features/ui/organisms/route-sheet/service/RouteSheet.service';

@Component({
  selector: 'app-place-location-details-popup',
  templateUrl: './place-location-details-popup.component.html',
  styleUrls: ['./place-location-details-popup.component.css'],
  animations: [
    trigger('mostrarHerramientas', [
      state('visible', style({ opacity: 1, height: '*' })),
      state('hidden', style({ opacity: 0, height: '0', overflow: 'hidden', display: 'none' })),
      transition('visible <=> hidden', animate('300ms ease-in-out'))
    ])
  ]
})
export class PlaceLocationDetailsPopUpComponent {

  EnumDetailIconNames = EnumDetailIconNames;
  EnumGenericDetailProperties = EnumGenericDetailProperties;

  selectedTabIndex: number = 0;
  locationDTO: LocationDTO = {} as LocationDTO;
  locationCategoryShortName: string = "";
  keys: string[] = [];
  values: string[] = [];
  keyNames: DataNamesDTO[] = [];
  arrayMaster: any[] = [];
  images: string[] = [];
  isLoadingImages: boolean = true;
  parentCordX = "";
  parentCordY = "";
  FlyToOnOpen = false;
  FlyToParentOnClose = false;
  activeSourceName: string = null;
  Coords: string = "";
  isToolButtonPressed: boolean = false;

  routeSheets: RouteSheetTab[] = [];
  locationCategory: LocationCategoryDTO = null;

  detallesActivo: string[] = [];
  detallesGPS: string[] = [];

  isLoading : boolean = true;
  fullScreen: boolean = false;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  newDialogRef: MatDialogRef<PlaceLocationDetailsPopUpComponent>;
  
  location_details_subscription: Subscription;

  constructor(
    public dialogRef: MatDialogRef<PlaceLocationDetailsPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private routeSheetUtilService: RouteSheetUtilService,
    private mapHelperService: MapHelperService,
    private locationService: LocationsService,
    private notifyService: SwalNotificationService,
    private citronellaActionsService: CitronellaActionsService,
    private notificationsToastService: NotificationsToastService,
    private dialog: MatDialog,
    private localStorageService: LocalStorageService,
    private routeSheetService: RouteSheetService,
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 769px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    if(!environment.production) console.log("data", data);

    this.locationDTO.identifier = data.identifier != null ? data.identifier : '';
    this.parentCordX = data.parentCoordX;
    this.parentCordY = data.parentCoordY;
    this.FlyToOnOpen = data.FlyToOnOpen != null ? data.FlyToOnOpen : false;
    this.FlyToParentOnClose = data.FlyToParentOnClose != null ? data.FlyToParentOnClose : false;
    this.activeSourceName = data.activeSourceName != null ? data.activeSourceName : null;

    this.GetLocation();
  }

  ngOnInit(): void {
    if (!!this.data.routeSheetLocation && this.data.routeSheetLocation.noOrder == 1) {
      // this.routeSheetUtilService.setRouteFromFirstLocationToParent(this.data.routeSheetLocation);
    }

    
  }

  ngOnDestroy(): void {
    if (this.location_details_subscription)
      this.location_details_subscription.unsubscribe();

    if (this.newDialogRef)
      this.newDialogRef.close();

    // this.routeSheetUtilService.clearRouteToPointLayer();
    this.clearActiveLayer();
    if (!!this.parentCordX && !!this.parentCordY && this.FlyToParentOnClose) {
      this.mapHelperService.FlyToCamera(this.parentCordY, this.parentCordX, "15");
    }

    if(this.locationCategory != null){
      this.routeSheetService.clearRouteSheetLayers(this.locationCategory.shortName);
    }
  }

  GetLocation(){
    this.isLoading = true;
    this.location_details_subscription = this.locationService.getByIdentifier(this.locationDTO.identifier).subscribe({
      next: async (data: EstatusJSON) => {
        if (data.isSuccess == true && data.result != null) {
          var properties = data.result;
          if(!environment.production) console.log("related Data", properties);
          await this.setDetailsData(properties);
          this.isLoading = false;
        } else {
          Sentry.captureMessage('PlaceLocationDetailsPopup.GetLocation: datos no disponibles', { level: 'warning', extra: { identifier: this.locationDTO.identifier, response: data } });
          this.isLoading = false;
          this.notifyService.message(
            "Se están cargando los detalles. Inténtelo de nuevo más tarde.",
          );
          if(this.location_details_subscription)
            this.location_details_subscription.unsubscribe();
          this.dialogRef.close();
        }
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener locacion por identificador (popup general)', error);
        this.isLoading = false;
        this.notifyService.message("Error al cargar los detalles.");
        if(this.location_details_subscription)
          this.location_details_subscription.unsubscribe();
        this.dialogRef.close();
      }
    });
  }

  async setDetailsData(properties: any) {
      this.locationDTO = {
        identifier: properties.identifier,
        description: properties.description,
        lastVoltaje: properties.lastVoltage,
        batteryPercent: properties.batteryPercent,
        gpsStatus: properties.lastGPSStatus,
        canLock: properties.canLock,
        lastUpdate: properties.lastUpdate,
        activeType: properties.Tipo,
        id: properties.id,
        statusVehiculo: properties.statusVehiculo,
        idLocationCategory: properties.idLocationCategory,
        locationCategory: properties.locationCategory,
        icon: properties.icon,
        panelIcon: properties.icon,
        cordsY: properties.cordsY,
        cordsX: properties.cordsX,
        alias: properties.alias,
        categoryStatus: properties.categoryStatus,
        idLocationCategoryStatus: properties.idLocationCategoryStatus ?? 0,
        group: properties.group,
        subGroup: properties.subGroup,
    
        guid: '',
        color: '',
        data: [],
        counts: 0,
        isFullyAvailable: true,

        statusFlags: properties.statusFlags ? properties.statusFlags : [],
        flagTypes: properties.flagTypes ? properties.flagTypes : [],
      }
      const y = !isNaN(Number(this.locationDTO.cordsY)) ? Number(this.locationDTO.cordsY).toFixed(4) : null;
      const x = !isNaN(Number(this.locationDTO.cordsX)) ? Number(this.locationDTO.cordsX).toFixed(4) : null;
      this.Coords = (y || '') + ", " + (x || '');

      // Obtener y asignar el nombre real de la categoría
      try {
        const categories = JSON.parse(this.localStorageService.getListaCategorias());
        if (categories) {
          const category = categories.find((cat: any) => cat.id === this.locationDTO.idLocationCategory);
          this.locationCategory = category ? category : null;
          const activeIcon = category ? category.activeIcon : null;
          console.log("frecuencia, category", category, this.parentCordX,this.parentCordY, !isNaN(Number(this.parentCordY)), !isNaN(Number(this.parentCordX)), this.activeSourceName,activeIcon);
          
          if(this.parentCordX && this.parentCordY && !isNaN(Number(this.parentCordY)) && !isNaN(Number(this.parentCordX)) && this.activeSourceName && activeIcon){
            this.setActiveLayer(Number(this.parentCordY), Number(this.parentCordX), this.activeSourceName, activeIcon);
          }
        }
      } catch (error) {
        console.error("Error al obtener el nombre real de la categoría", error);
      }
    
      if(!environment.production) console.log("SETDATA", properties);
      this.arrayMaster = Object.entries(properties.data);
      this.keys = [];
      this.values = [];
      this.arrayMaster.forEach((element) => {
        var obe: IGeoPosDataLocation;
        obe = JSON.parse(JSON.stringify(element[1]));
        this.keys.push(obe.key);
        this.values.push(obe.value);
      });

      //Crea arrays de detalles del activo
      this.detallesActivo = this.keys.filter((item) => !item.includes("GPS"));
      // this.detallesActivo.sort();
      //Crea arrays de detalles del GPS
      this.detallesGPS = this.keys.filter((item) => item.includes("GPS"));
      // this.detallesGPS.sort();

      if(!environment.production) console.log("detalles", this.keys, this.detallesActivo, this.detallesGPS);
    
      // Hacer ambas llamadas en paralelo
      // const [keyNamesResult, imagesResult] = await Promise.all([
      //   firstValueFrom(this.locationService.getDataNames(this.keys)),
      //   this.citronellaActionsService.GetExternalImages(this.locationDTO.idLocationCategory, this.locationDTO.identifier),
      // ]);


      const keyNamesResult = await firstValueFrom(this.locationService.getDataNames(this.keys.concat([this.locationDTO.locationCategory])));

      if (keyNamesResult.isSuccess) {
        this.keyNames = keyNamesResult.result;
      }
  
      // Cargar imágenes de forma asíncrona sin bloquear
      this.loadImagesAsync();

      //cargar routeSheet
      this.getChildrenLocations();

      if (!!this.locationDTO.cordsX && !!this.locationDTO.cordsY && this.FlyToOnOpen) {
        this.mapHelperService.FlyToCamera(this.locationDTO.cordsY, this.locationDTO.cordsX, "15");
      }
    }

  getUsableName(keyName: string): string {
    const keyNameObject = this.keyNames.find((item) => item.keyName == keyName);
    return keyNameObject ? keyNameObject.usableName : keyName;
  }

  //Obtiene la visibilidad según el nombre de la key
  getNameVisibility(keyName) {
    const keyNameObject = this.keyNames.find(
      (item) => item.keyName === keyName
    );
    return keyNameObject ? keyNameObject.isVisible : true;
  }

  CancelButton() {
    this.dialogRef.close();
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
    this.notificationsToastService.showSuccess("Texto copiado al portapapeles", text);
  }

  toggleToolButton() {
    this.isToolButtonPressed = !this.isToolButtonPressed;
  }

  selectTab(event: MatTabChangeEvent) {
    this.selectedTabIndex = event.index;
  }

  openDetailPanel(identifier: any) {
    this.newDialogRef = this.dialog.open(PlaceLocationDetailsPopUpComponent, {
      maxWidth: "98vw",
      maxHeight: "92vh",
      autoFocus: false,
      restoreFocus: false,
      hasBackdrop: false,
      disableClose: true,
      data: {
        identifier: identifier,
        parentCoordX: this.locationDTO.cordsX,
        parentCoordY: this.locationDTO.cordsY,
        FlyToOnOpen: true,
        FlyToParentOnClose: true
      }
    });

    this.newDialogRef.afterClosed().subscribe(result => {
      
    });
  }

  private loadImagesAsync() {
    this.citronellaActionsService.GetExternalImages(this.locationDTO.idLocationCategory, this.locationDTO.identifier).then(imagesResult => {
      if (imagesResult != null && imagesResult.length > 0) {
        this.images = imagesResult;
        this.isLoadingImages = false;
      }else{
        this.images = [];
        this.isLoadingImages = false;
      }
    }).catch(error => {
      this.images = [];
      this.isLoadingImages = false;
    });
  }

  setActiveLayer(lat: number, lng: number, sourceName: string, activeIcon: string): void {
    this.mapHelperService.UpdateActivePoint(lat, lng, sourceName, activeIcon);
    this.mapHelperService.MoveLayerToTop(sourceName);
  }

  clearActiveLayer(): void {
    if(!this.activeSourceName) 
      return;
    this.mapHelperService.UpdateLayerGeoJson(this.activeSourceName, this.mapHelperService.Empty_GeoJson);
  }

  getChildrenLocations(){
    var categoriesList = JSON.parse(this.localStorageService.getListaCategorias()).filter((item) => item.name.includes(EnumLocationCategories.Unit));
    // var categoriesList = []
    if(!environment.production) console.log("generic categorias", categoriesList);
    this.routeSheets = [];
      categoriesList.forEach((element) => {
      this.routeSheets.push({
        total: "-",
        routeSheetName: element.shortName,
        routeSheetIdLocationCategory: element.id,
      });
    });
  }

  loadTotal(total: string, routeSheet: RouteSheetTab) {
    routeSheet.total = total;
  }
}
